import Axios from "axios"
import { sortCaret } from "../../../_metronic/_helpers";
import React from "react";
import { Badge} from "react-bootstrap"/* const url_categories_dev = "http://localhost:5000/gt-out/us-central1/api/v1/categories"; */
const url_categories = process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + "/v1/metrics";

export const columns = [
  {
    dataField: "sufix",
    text: "Sufix",
    sort: true,
sortCaret: sortCaret,
    formatter: (cellContent, row) => <h5><Badge variant="info">{row?.sufix}</Badge></h5>,

  },
  {
    dataField: "name",
    text: "Metric Name",
    sort: true,
sortCaret: sortCaret,
  },
  {
    dataField: "description",
    text: "Description",
    sort: true,
sortCaret: sortCaret,
  }
];

export function getClients(setCategory) {
  Axios.get(`${url_categories}/find`)
    .then((res) => {
      const categories = res.data.payload;
      console.log(categories)
      setCategory(categories);
    })
    .catch(function (thrown) {
      if (Axios.isCancel(thrown)) {
          console.log(`request cancelled:${thrown.message}`)
      } else {
          console.log('another error happened')
      }
  })
}
export function getClient(uid = "") {
  return Axios.get(`${url_categories}/find/${uid}`)

}
export function updateClient(category) {
  if (category.uid) {

    return Axios.put(`${url_categories}/update/${category.uid}`, category);
  } else {
    return Axios.post(`${url_categories}/create`, category);

  }
}
export function deleteClient(uid) {
  return Axios.delete(`${url_categories}/delete/${uid}`)
}